import React, { useEffect, useState } from 'react'

import { Grid, GridColumn } from '@progress/kendo-react-grid';
import { useLocation } from 'react-router-dom';

import Section from '../Section';
import { fetchTabaHavotDaatData } from '../../server/ServerFunc';
import AppHeaderGlobal from '../AppHeaderGlobal';
import AppFooter from '../AppFooter';


const HavotDaatInfo = ({ isSeparate }) => {
	const [havotDaatList, setHavotDaatList] = useState([]);
	const titles = {
		"goremName": "שם הגורם",
		"taarihBakasha": "תאריך בקשה",
		"taarihKabala": "תאריך קבלה"
	}

	const search = useLocation().search;

	useEffect(() => {
		const tikNumURL = new URLSearchParams(search).get("TikNum");
		const systemCodeURL = new URLSearchParams(search).get("SystemCode");
		getHavotDaatContent(systemCodeURL, tikNumURL);
	}, []);

	const getHavotDaatContent = async (systemCode, tikNum) => { 
		const havotDaatData = await fetchTabaHavotDaatData(systemCode, tikNum);
		if(havotDaatData.length > 0) {
			setHavotDaatList(havotDaatData);
		} else {
			setHavotDaatList([]);
		}
	}

  	const LabeledDataItem = (label, value) => {
		return <div className="labeled-grid-cell">
			<div className="label">{label}</div>
			<div className="value">{value}</div>
		</div>
	}

  	const LabeledCell = (props) => {
		return <td {...props.tdProps}>
			{LabeledDataItem(titles[props.field], props.dataItem[props.field])}
		</td>
	}

	const HavotDaatTable = () => {
		return (
			havotDaatList.length > 0 ?
				<Grid data={havotDaatList} >
					<GridColumn field="goremName" title={titles.goremName} cell={LabeledCell} />
					<GridColumn field="taarihBakasha" title={titles.taarihBakasha} cell={LabeledCell} />
					<GridColumn field="taarihKabala" title={titles.taarihKabala} cell={LabeledCell} />
				</Grid>
				:
				<div style={{ textAlign: "center", margin: "auto" }}>לא נמצאו נתונים</div>
		)
	}

	return (
		<>
			{ isSeparate && <AppHeaderGlobal /> }
			{
				<div className="container my-3 my-lg-5">
					<Section icon={'eye'} title={'חוות דעת נדרשות'} className="mt-3">
						<HavotDaatTable />
					</Section>
				</div>
			}
			{ isSeparate && <AppFooter /> }
		</>
	)
}

export default HavotDaatInfo